import { apiFetch, OTP_API } from "./api";

export async function sendOtp(contact: string) {
  return apiFetch<{ success: boolean; message?: string }>(
    `${OTP_API}/send`,
    { method: "POST", body: { contact, type: "sms" } }
  );
}

export async function verifyOtp(contact: string, otp: string) {
  return apiFetch<{ status: string; message: string }>(
    `${OTP_API}/verify`,
    { method: "POST", body: { contact, otp, type: "sms" } }
  );
}
